import { Container } from '@mui/material';
import React from 'react';

import {
  WinnerQuotePhoto,
  type WinnerQuotePhotoProps,
} from '@/competitions/_common/components/WinnerQuotePhoto.tsx';

import { Section } from '../_components/Section.tsx';

export type QuoteSectionProps = WinnerQuotePhotoProps;

export const QuoteSection: React.FC<QuoteSectionProps> = (props) => {
  return (
    <Section variant="blue">
      <Container disableGutters maxWidth="xl">
        <WinnerQuotePhoto {...props} noPadding large />
      </Container>
    </Section>
  );
};
